import axiosInstance, { axiosInstanceForm } from "../../utils/AxiosInstance";

export const CreateSiteApi = async (data) => {
  let snackBarData = {};
  try {
    let response = await axiosInstance.post("/JobSite/Create", data);

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.msg,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.msg,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};

export const CreateExcelApi = async (data) => {
  let snackBarData = {};
  try {
    let response = await axiosInstanceForm.post("/JobSite/CreateExcel", data);

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.msg,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.msg,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};
export const CreateEquipmentWorkingExcel = async (data) => {
  let snackBarData = {};
  try {
    let response = await axiosInstanceForm.post(
      "/JobSite/CreateEquipmentWorkingExcel",
      data
    );

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.msg,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.msg,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};
export const CreateComponentWorkingExcel = async (data) => {
  let snackBarData = {};
  try {
    let response = await axiosInstanceForm.post(
      "/JobSite/CreateComponentWorkingExcel",
      data
    );

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.msg,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.msg,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};
export const UpdateSiteApi = async (id, data) => {
  let snackBarData = {};
  try {
    let response = await axiosInstance.patch(`/JobSite/Update/${id}`, data);

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.msg,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.msg,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};
export const DeleteSiteApi = async (id) => {
  let snackBarData = {};
  try {
    let response = await axiosInstance.delete(`/JobSite/Delete/${id}`);

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.msg,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.msg,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};
